export default "__VITE_ASSET__CPmc2Xuh__"